import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import rootReducer from '../reducers/root_reducer';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

// only 'rehydrates'/persist model_pipeline reducer
const persistConfig = {
    key: 'wi_author',
    storage,
    stateReconciler: autoMergeLevel2,
    blacklist: ["model_uploader", "attachments", "devices", "errors", "feedback", "management", "models", "previewer", "notifications", "session", "tags", "work_instructions", "wi_errors", "users"]
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Reverted logger to be always on as per user request
const middleWare = applyMiddleware(thunk, logger);

export const configureStore = (preloadedState = {}) => {
    return createStore(persistedReducer, preloadedState, composeWithDevTools(middleWare));
};

export const persistor = (store) => persistStore(store);